import { STORAGE_KEYS } from "./logoutSession";

type CompleteSignUpResponse = {
    data?: { id_token?: string; refresh_token?: string };
    id_token?: string;
    refresh_token?: string;
};

export type CompleteSignUpInput =
    | { skipPhone: true }
    | { skipPhone?: false; ddi: number; phone: string };

export async function requestCompleteSignUp(
    input: CompleteSignUpInput,
): Promise<{ idToken: string; refreshToken: string | null }> {
    const idToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
    const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH);

    if (!idToken) {
        throw new Error("Sessão expirada. Faça login novamente.");
    }

    if (!refreshToken) {
        throw new Error(
            "Sessão incompleta (sem refresh_token). Faça login novamente com Google/Apple.",
        );
    }

    const body: Record<string, unknown> = input.skipPhone
        ? { registration_completed: true, refresh_token: refreshToken }
        : {
              phone_ddi: `+${input.ddi}`,
              phone_number: input.phone,
              registration_completed: true,
              refresh_token: refreshToken,
          };

    const res = await fetch(`${import.meta.env.VITE_API_URL}/user/complete_sign_up`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
        },
        body: JSON.stringify(body),
    });

    if (!res.ok) {
        const err = (await res.json().catch(() => ({}))) as { message?: string };
        throw new Error(err.message ?? `Falha ao concluir cadastro (${res.status})`);
    }

    const json = (await res.json()) as CompleteSignUpResponse;
    const updatedIdToken = json?.data?.id_token ?? json?.id_token ?? null;
    const updatedRefreshToken = json?.data?.refresh_token ?? json?.refresh_token ?? null;

    if (!updatedIdToken) {
        throw new Error("Backend não retornou id_token atualizado após complete_sign_up.");
    }

    return {
        idToken: updatedIdToken,
        refreshToken: updatedRefreshToken,
    };
}
